import { Eye } from 'lucide-react'
import { eventIcons, getDotColor } from '../utils/eventMappings'
import { formatEventTime, formatChangeValue } from '../utils/formatters'
import { formatEventHumanReadable } from '../utils/formatEventHumanReadable'
import type { DashboardOrderEvent } from '../types/dashboard.types'

interface TimelineItemProps {
  event: DashboardOrderEvent
}

export function TimelineItem({ event }: TimelineItemProps) {
  const Icon = eventIcons[event.event_type] ?? eventIcons.notification
  const dotColor = getDotColor(event.event_type)
  const humanLabel = formatEventHumanReadable(event)
  const detail = formatChangeValue(event)

  return (
    <div className="relative pb-4 last:pb-0">
      {/* Dot */}
      <div
        className={`absolute -left-7 top-0.5 w-5 h-5 rounded-full flex items-center justify-center z-[1] ${dotColor.bg}`}
      >
        <Icon size={10} className={dotColor.icon} />
      </div>

      {/* Content box */}
      <div className="bg-gray-50 rounded-md px-3.5 py-2.5">
        <p className="text-[13px] font-medium text-gray-900">{humanLabel}</p>
        {detail && (
          <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{detail}</p>
        )}
        <div className="flex items-center gap-2 mt-1 text-[11px] text-gray-400">
          {event.sender_name && <span>{event.sender_name}</span>}
          {event.sender_name && (
            <div className="w-[3px] h-[3px] rounded-full bg-gray-400" />
          )}
          <span>{formatEventTime(event.created_at)}</span>
          {event.visible_to_customer && (
            <>
              <div className="w-[3px] h-[3px] rounded-full bg-gray-400" />
              <span className="inline-flex items-center gap-1 text-[10px] text-emerald-600 bg-emerald-50 px-1.5 py-px rounded-lg font-medium">
                <Eye size={10} />
                Delt med kunde
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
